import Layout from '../components/Layout'
import IntroLong from '../components/introduction/IntroLong'

export default function v1() {
  return (
    <Layout title="Landslide" url="v1" fullScreen v1>
      <div id="introduction">
        <IntroLong />
      </div>
    </Layout>
  )
}
